module.exports = __webpack_public_path__ + "img/key-mark.9330dd3c.svg";